import { render, staticRenderFns } from "./SmartRecovery.vue?vue&type=template&id=7d873f87&"
import script from "./SmartRecovery.vue?vue&type=script&lang=ts&"
export * from "./SmartRecovery.vue?vue&type=script&lang=ts&"
import style0 from "./SmartRecovery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VApp,VContent})
